<p>You have been logged out. Click the button to log in again.</p>
<button class="button--primary" (click)="login()" mat-button>Login</button>
